import { CheckCircleTwoTone, LinkOutlined } from "@ant-design/icons";
import { Modal, Tooltip, Typography } from "antd";
import { LinkWrapper, LoadingListEntityProfile } from "Explore/Components";
import { useRef, useState } from "react";
import styles from "./FacultyExperiences.module.scss";
import LoginRequiredSection from "Explore/Components/LoginRequired";
import useAuth from "Hooks/useAuth";
import { encryptObjectToAsterisk } from "Explore/Utils";

const { Paragraph, Text, Link } = Typography;
const QuotationAndCitation = ({ quotation, citationURL }) => {
  const displayText = quotation.length > 0 ? quotation : "";
  return (
    <div>
      <Paragraph>
        <Link href={citationURL} target="_blank" rel="noreferrer">
          <LinkOutlined />
        </Link>
        &nbsp;
        <Text type="secondary" style={{ fontStyle: "italic" }}>
          {displayText}
        </Text>
        <Tooltip title={citationURL}></Tooltip>
      </Paragraph>
    </div>
  );
};
const Experience = ({ experience: _experience, data_source_url, encoded }) => {
  const experience = encoded
    ? encryptObjectToAsterisk(_experience)
    : _experience;

  const render = () => (
    <div className={styles["experience"]}>
      <div className={styles["experience-info"]}>
        <div className={styles["title"]}>
          <Tooltip title={!!data_source_url ? "Verified" : "Not yet verified"}>
            <CheckCircleTwoTone
              twoToneColor={!!data_source_url ? "#52c41a" : "lightgray"}
            />
          </Tooltip>
          <div className={styles["information"]}>
            <p className={styles["inst-name"]}>{experience.institution}</p>
            <p className={styles["sub-title"]}>
              {!!experience.position_title && (
                <span>Position: {experience.position_title} </span>
              )}
              {!!experience.from_year && !!experience.to_year && (
                <span>
                  ({experience.from_year}-{experience.to_year})
                </span>
              )}
            </p>
          </div>
        </div>

        {experience.raw?.length > 0 && (
          <QuotationAndCitation
            quotation={`"...` + experience.raw.join(". ") + `..."`}
            citationURL={data_source_url}
          />
        )}
      </div>
    </div>
  );
  return encoded ? (
    render()
  ) : (
    <LinkWrapper link={data_source_url} target="_blank" rel="noreferrer" component={render()} />
  );
};

const FacultyExperiences = ({ data }) => {
  const { userTypeConfig } = useAuth({
    entityType: "FACULTY",
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [minHeight, setMinHeight] = useState(0);
  const ref = useRef(null);
  const isShow = !!userTypeConfig?.ui_components?.experience;

  return (
    <div className={styles["faculty-detail-experiences"]}>
      {data.data.length > 0 ? (
        <div className={styles["faculty-detail-experiences-landscape"]}>
          <div className={styles["list-experiences-title"]}>
            <h2 className={styles["title"]}>Experiences</h2>
          </div>
          <LoadingListEntityProfile
            isLoading={data.isLoading}
            component={
              <div
                style={{
                  minHeight,
                  position: "relative",
                }}
              >
                {!isShow && (
                  <LoginRequiredSection
                    blur
                    ref={ref}
                    setHeight={setMinHeight}
                  />
                )}
                {data?.data.slice(0, 3).map((item, index) => {
                  return (
                    <Experience
                      experience={item}
                      key={index}
                      data_source_url={data.source_url}
                      encoded={!isShow}
                    />
                  );
                })}
                {data.data.length > 3 && (
                  <div className={styles["see-more"]}>
                    <p onClick={() => isShow && setIsModalOpen(true)}>
                      See {data.data.length - 3} more
                    </p>
                  </div>
                )}
              </div>
            }
            componentNum={3}
            rows={2}
            avatar={true}
          />
          <Modal
            title="List Experiences"
            open={isModalOpen}
            onOk={() => setIsModalOpen(false)}
            onCancel={() => setIsModalOpen(false)}
            width={"70%"}
            style={{
              top: "50px",
            }}
            zIndex={1002}
          >
            <div style={{ overflowY: "auto", height: "500px" }}>
              {data?.data.map((item, index) => {
                return (
                  <Experience
                    experience={item}
                    key={index}
                    data_source_url={data.source_url}
                  />
                );
              })}
            </div>
          </Modal>
        </div>
      ) : (
        <div></div>
      )}
      <div className={styles["faculty-detail-experiences-mobile"]}>
        {data?.data.map((item, index) => {
          return (
            <Experience
              experience={item}
              key={index}
              data_source_url={data.sourceUrl}
            />
          );
        })}
      </div>
    </div>
  );
};

export default FacultyExperiences;
